import React from "react";

const instructionsHeaderInlineStyle = {
  fontSize: '20px'
}

const formatInstructions = (instructions) => {
  if (!Array.isArray(instructions)) return null;

  return (
    <ol className="ol-bold-key-and-spaced-value" style={{ textAlign: "left", padding: "5px", margin: 0 }}>
      {instructions.map((instruction) => (
        <li>
          <div className="_title">
            <div>{`${instruction.title}:`}</div>
            <div>{instruction.description}</div>
          </div>
        </li>
      ))}
    </ol>
  );
};

export const ONR_CwrMaintenanceRecordFormSectionsSchema = {
  generalInfo: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: {
      header1: "grey-background",
      header2: "grey-background",
    },
    minDataRowsCount: 5,
    columns: [
      {
        title: "General Information",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Date",
            colSpan: 2,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "date",
          },
          {
            title: "Subdivision",
            colSpan: 3,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "subdiv",
          },
          {
            title: "Mile",
            colSpan: 2,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "mile",
          },
          {
            title: "M/S",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "mside",
          },
          {
            title: "E/W Rail",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "ewrail",
          },
          {
            title: "Weight",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "wght",
          },
          {
            title: "Temperature",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "temp",
          },
          {
            title: "Defect Type",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "dtype",
          },
          {
            title: "DR (inches)",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "disrail",
          },
        ],
      },
    ],
  },
  nonConformance: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: {
      header1: "grey-background",
      header2: "grey-background",
    },
    minDataRowsCount: 5,
    columns: [
      {
        title: "Non-Conformance",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Date",
            colSpan: 2,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "date",
          },
          {
            title: "Subdivision",
            colSpan: 3,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "subdiv",
          },
          {
            title: "Mile",
            colSpan: 2,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "mile",
          },
          {
            title: "Rail +/-",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "railar",
          },
          {
            title: "Anchors",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "anch",
          },
          {
            title: "Foreman",
            colSpan: 3,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "finit",
          },
          {
            title: "Comments",
            colSpan: 5,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "com",
          },
        ],
      },
    ],
  },
  repairOfCwrDefects: {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: {
      header1: "grey-background",
      header2: "grey-background",
    },
    minDataRowsCount: 5,
    columns: [
      {
        title: "Repair of CWR Defects",
        colSpan: 20,
        rowSpan: 1,
        className: "tbl-text-normal",
        columns: [
          {
            title: "Date",
            colSpan: 2,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "date",
          },
          {
            title: "Subdivision",
            colSpan: 3,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "subdiv",
          },
          {
            title: "Mile",
            colSpan: 2,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "mile",
          },
          {
            title: "Rail +/-",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "railar1",
          },
          {
            title: "Anchors",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "anch1",
          },
          {
            title: "Date Repaired",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "daterep",
          },
          {
            title: "Foreman",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "forma",
          },
          {
            title: "Comments",
            colSpan: 5,
            rowSpan: 1,
            className: "tbl-text-normal",
            accessor: "com1",
          },
        ],
      },
    ],
  },
  instructionsTableHeader: {
    heights: {
      header1: "auto",
    },
    headerOnly: true,
    classes: {
      header1: "grey-background",
    },
    inlineStyle: {
      header1: instructionsHeaderInlineStyle,
    },
    columns: [
      {
        title: "Guidelines",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
      },
    ],
  },
  instructionsTable: {
    heights: {
      header1: "auto",
    },
    classes: {
      header1: "grey-background",
    },
    inlineStyle: {
      header1: instructionsHeaderInlineStyle,
    },
    minDataRowsCount: 1,
    columns: [
      {
        title: "General Information",
        colSpan: 4,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "generalInfo",
        formatter: formatInstructions,
      },
      {
        title: "Non-Conformance",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "nonConformance",
        formatter: formatInstructions,
      },
      {
        title: "Repair of CWR Defects",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "repairOfCwrDefects",
        formatter: formatInstructions,
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/CwrMaintenanceRecordForm/ONR_CwrMaintenanceRecordFormSchema.js